import {StyleSheet} from 'react-native';
import CommonStyles from '../../utils/CommonStyles';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// (tagContainer) are preserved — the factory returns them closed over the
// theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.backgroundMuted,
    },
    marginHorizontal24: {
      marginHorizontal: 24,
    },
    marginVertical16: {
      marginVertical: 16,
    },
    marginTop16: {
      marginTop: 16,
    },
    pageViewContainer: {
      marginBottom: 16,
      marginTop: 16,
    },
    tagContainer: index => ({
      padding: 8,
      borderRadius: 8,
      backgroundColor: colors.surface,
      marginLeft: index == 0 ? 0 : 16,
    }),
    emptyListContainer: {
      marginTop: 100,
      marginBottom: 50,
      alignItems: 'center',
    },
    cards: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      flexShrink: 0,
      flexWrap: 'wrap',
      alignItems: 'stretch',
      gap: '32px',
    },
    webPadding: {
      ...CommonStyles.pt_24,
      ...CommonStyles.pb_36,
    },
    headerTextContainer: {
      ...CommonStyles.flex_row,
      ...CommonStyles.items_center,
    },
    webSearchContainer: {
      ...CommonStyles.flex_row,
      ...CommonStyles.self_end,
    },
    mhMinus24: {
      marginHorizontal: -24,
    },
  });

export default makeStyles;
